import { useState } from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

import {
  Checkbox,
  CssBaseline,
  FilledInput,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import { useAuthService } from "../../service/auth";
import Auth from "../../utils/assets/Auth.png";
import { ISignIn } from "../../service/auth/interfaces/ISignIn";
import { CustomCircularProgressFullScreen } from "../../components/CustomCircularProgress";
import logoLight from "../../utils/assets/logoLight.png";
import logoMobileDark from "../../utils/assets/logoMobileDark.png";
interface Errors {
  email: string | null;
  password: string | null;
}
function AuthPage() {
  const theme = useTheme(); 
  const { signIn } = useAuthService();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<Errors>({
    email: null,
    password: null,
  });
  const clearError = () => {
    setErrors({
      email: null,
      password: null,
    });
  };
  const [loading, setLoading] = useState<boolean>(false);
  const validFields = () => {
    // Verifica se os campos obrigatórios foram preenchidos
    if (!email.trim() || !email.includes("@")) {
      setErrors((prevState) => ({
        ...prevState,
        email: "❌ Campo obrigatório",
      }));
      return false;
    }
    if (!password.trim()) {
      setErrors((prevState) => ({
        ...prevState,
        password: "❌ Campo obrigatório",
      }));
      return false;
    }
    return true;
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    clearError();
    if (!validFields()) return;

    setLoading(true);
    const signInData: ISignIn = { email, password };

    try {
      const response = await signIn(signInData);
      setLoading(false);
      if (response.status === 200) {
        const token = response.data;
        localStorage.setItem("token", JSON.stringify(token));
        localStorage.setItem("profile", token.Profile);
        localStorage.setItem("Login", token.Login);
        setLoading(true);
       window.location.reload();
       // navigate("/reversal");
      } else {
        setErrors((prevState) => ({
          ...prevState,
          password: "❌ Credenciais Incorretas",
          email: " ",
        }));
      }
    } catch (erro) {
      setLoading(false);
      console.error("An error occurred:", erro);
    }
  };
  return (
    <React.Fragment>
      {loading && <CustomCircularProgressFullScreen />}
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${Auth})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
            }}
          >
            <Grid container spacing={2}>
              <Grid
                xs={12}
                md={12}
                lg={12}
                xl={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={
                    theme.palette.mode === "dark" ? logoMobileDark : logoLight
                  }
                  srcSet={
                    theme.palette.mode === "dark" ? logoMobileDark : logoLight
                  }
                  alt="Arcos Dourados"
                  width={350}
                />
                <Typography variant="overline" display="block" gutterBottom>
                  BEM-VINDO(A)
                </Typography>
              </Grid>
              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                sx={{ flex: 1 }}
              >
                <Grid xs={12} md={12} lg={12} xl={12}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Endereço de e-mail"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    variant="filled"
                    value={email}
                    error={!!errors.email}
                    helperText={errors.email || ""}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </Grid>
                <Grid xs={12} md={12} lg={12} xl={12}>
                  <FormControl
                    fullWidth
                    variant="filled"
                    error={!!errors.password}
                  >
                    <InputLabel htmlFor="password">Senha *</InputLabel>
                    <FilledInput
                      id="password"
                      required
                      fullWidth
                      name="password"
                      autoComplete="current-password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                      error={!!errors.password}
                      aria-describedby="component-password-error-text"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    {!!errors.password && (
                      <FormHelperText
                        id="component-password-error-text"
                        error={!!errors.password}
                      >
                        {errors.password || ""}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid xs={12} md={12} lg={12} xl={12}>
                  <FormControlLabel
                    control={<Checkbox value="remember" color="primary" />}
                    label="Lembrar"
                  />
                </Grid>
                <Grid xs={12} md={12} lg={12} xl={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2, color: "yellow" }}
                    style={{ color: "white", background: "#FFC72C" }}
                  >
                    Entrar
                  </Button>
                </Grid>
              </Box>
              <Grid
                xs={12}
                md={12}
                lg={12}
                xl={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              ></Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default AuthPage;
